import React from 'react';
import { Card } from 'semantic-ui-react';
import { ChildrenPropType } from '../../../../../foundation/types/component';
import './Content.css';
export default function Content(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Card.Content, null, children);
}